import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { format } from "date-fns";
import { id as locale } from "date-fns/locale";
import { logout, getLocalAuth } from "../utils/AuthUtils.js";
import { baseUrl, version_app } from "../constants/Constant.js";

function Navbar() {
  const values = getLocalAuth();
  const profile = JSON.parse(values.authLocal);

  const [date, setDate] = useState(new Date());
  const [imageLoaded, setImageLoaded] = useState(false);

  useEffect(() => {
    const timer = setInterval(() => {
      setDate(new Date());
    }, 1000);

    return () => {
      clearInterval(timer);
    };
  }, []);

  const handleImgLoadingError = (e) => {
    if (!imageLoaded) {
      // default image add, if associated image is not available...
      e.target.src = "../assets/images/default-profile.png";

      setImageLoaded(true); // Set imageLoaded to true to prevent further retries
    }
  };

  return (
    <nav className="navbar navbar-expand">
      <div className="left-topbar d-flex align-items-center">
        <a href="#section" className="toggle-btn">
          <i className="bx bx-menu"></i>
        </a>
      </div>
      <div className="flex-grow-1 ">
        <h4 className="logo-text">WMS-RFID v{version_app}</h4>
      </div>
      <div className="right-topbar ms-auto">
        <ul className="navbar-nav">
          <li className="nav-item dropdown dropdown-user-profile">
            <div className="d-flex user-box align-items-center">
              <div className="user-info">
                <p className="user-name mb-0">
                  {format(date, "EEEE, dd MMMM yyyy", { locale })}
                </p>
                <p className="designattion mb-0">
                  {format(date, "HH : mm : ss", { locale })}
                </p>
              </div>
            </div>
          </li>
          <li className="nav-item dropdown dropdown-user-profile">
            <a
              className="nav-link dropdown-toggle dropdown-toggle-nocaret"
              href="#section"
              data-bs-toggle="dropdown"
            >
              <div className="d-flex user-box align-items-center">
                <div className="user-info">
                  <p className="user-name mb-0">{profile.data.name}</p>
                  <p className="designattion mb-0">
                    {profile.data.privilege.name}
                  </p>
                </div>
                <img
                  src={`${baseUrl}/${profile.data.image}`}
                  className="user-img"
                  alt="user avatar"
                  onLoad={() => setImageLoaded(true)} // Set imageLoaded to true when the image loads successfully
                  onError={handleImgLoadingError}
                />
              </div>
            </a>
            <div className="dropdown-menu dropdown-menu-end">
              <a className="dropdown-item" href="/admin/profile">
                <i className="bx bx-user-circle"></i>
                <span>Profile</span>
              </a>
              <div className="dropdown-divider mb-0"></div>{" "}
              <Link
                to="/auth/login"
                className="dropdown-item"
                onClick={() => logout()}
              >
                <i className="bx bx-power-off"></i>
                <span>Logout</span>
              </Link>
            </div>
          </li>
        </ul>
      </div>
    </nav>
  );
}

export default Navbar;
